import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Subscription } from "rxjs";
import { RegConfigService } from "src/app/pages/admin/reg-config-service";
import { UserDialogComponent } from "./Forms/user-dialog.component";
import { UserManagementService } from "../user-management.service";
import Swal from "sweetalert2";
import { AdminService } from "../../admin/admin-service";
import { RoleDialogComponent } from "./Forms/role-dialog/role-dialog/role-dialog.component";
import { SearchDialogComponent } from "./Forms/search-dialog.component";
import { MixinFunctionsService } from "../../services/mixin-functions.service";

@Component({
  selector: "app-user-management",
  templateUrl: "./user-management.component.html",
  styleUrls: ["./user-management.component.scss"],
})
export class UserManagementComponent implements OnInit {
  subs: Subscription[] = [];
  pageTitle = " Users List";
  displayedColumns: string[] = [
    "name",
    "checkNumber",
    "email",
    "mobile",
    "adminArea",
    "position",
    "roles",
    "actions",
  ];

  list: MatTableDataSource<any>;

  searchKey: string;
  loading = false;
  userTypes: any = [];
  roles: any = [];
  positions: any = [];
  usersList: any = [];
  rolesList: any = [];
  selectedAdminArea;
  userDialog: MatDialogRef<UserDialogComponent>;

  formData: any = {};
  params: any = {
    size: 20,
    page: 0,
  };

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  keyWord: any;

  constructor(
    private users: UserManagementService,
    public service: AdminService,
    public mixins: MixinFunctionsService,
    private dialog: MatDialog,
    private configService: RegConfigService
  ) {}

  preparedUsersList(response) {
    this.usersList =
      response && response.data
        ? response.data.map((item) => ({
            ...item,
            mobileNumber:
              item.mobileNumber === (undefined || null) ||
              item.mobileNumber?.toString()?.startsWith("0")
                ? item.mobileNumber
                : "0" + item.mobileNumber,
            userRoles:
              item.roles && item.roles.length > 0
                ? item.roles.map((r) => r.displayName).join(",")
                : null,
          }))
        : [];
    this.list = new MatTableDataSource(this.usersList);
    this.list.sort = this.sort;
  }

  get(data = null) {
    if (!(this.currentUser.adminArea && this.currentUser.adminArea.id)) {
      return Swal.fire("Logged in user has no admin Area  ", "", "info");
    }
    this.loading = true;
    const params = {
      adminAreaId:
        data && data !== null ? data.id : this.currentUser.adminArea.id,
      ...this.params,
    };

    this.subs.push(
      this.users.get(params).subscribe((response) => {
        this.preparedUsersList(response);
        this.loading = false;
        this.params.total = response.totalElements;
      })
    );
  }

  filterTable(data) {
    if (data.target.value.length > 3) {
    } else {
      this.get();
    }
  }

  create(payload) {
    if (payload.id) {
      this.update(payload);
    } else {
      this.save(payload);
    }
  }

  update(payload) {
    this.loading = true;
    this.users.update(payload).subscribe((response) => {
      if (response.code === 200) {
        this.loading = false;
        //Swal.fire(response.description, '', 'success');
        this.get();
        this.closeDialog();
      } else {
        //Swal.fire(response.description, '', 'error');
      }
    });
  }

  save(payload) {
    this.loading = true;
    this.users.create(payload).subscribe((response) => {
      if (response.code === 200) {
        // Swal.fire(response.description, '', 'success');
        this.get(this.selectedAdminArea);
        this.closeDialog();
        this.loading = false;
      } else {
        //Swal.fire(response.description, '', 'error');
      }
    });
  }

  resetPassword(data) {
    const payload: any = {};
    payload.id = data.id;
    payload.email = data.email;
    Swal.fire({
      title: "Are you sure you want to reset user Password ?",
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
      cancelButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.users.resetPassword(payload).subscribe((response) => {
          if (response.code === 200) {
            this.get(this.selectedAdminArea);
            this.loading = false;
            //Swal.fire(response.description, '', 'success');
            setTimeout(() => {
              Swal.close();
            }, 1000);
          } else {
            //Swal.fire(response.description, '', 'error');
          }
        });
      } else if (result.isDismissed) {
        Swal.fire("User password not reset", "", "info");
      }
    });
  }

  deactivateAccount(data) {
    const payload: any = {};
    payload.id = data.id;
    payload.enabled = data.enabled === false ? true : false;
    payload.active = data.enabled === false ? true : false;
    let action = data.enabled === false ? "activate " : "deactivate";

    Swal.fire({
      title: "Are you sure you want to " + action + "  user account ?",
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
      cancelButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.users.update(payload).subscribe((response) => {
          if (response.code === 200) {
            this.get(this.selectedAdminArea);
            this.loading = false;
            //Swal.fire(response.description, '', 'success');
            setTimeout(() => {
              Swal.close();
            }, 1000);
          } else {
            // Swal.fire(response.description, '', 'error');
          }
        });
      } else if (result.isDismissed) {
        Swal.fire("Cancelled ,user account not  " + action + "d", "", "info");
      }
    });
  }

  lockAccount(data) {
    const payload: any = {};
    payload.id = data.id;
    payload.accountNonLocked = data.accountNonLocked === false ? true : false;
    let action = data.accountNonLocked === false ? "Unlock" : "lock";
    Swal.fire({
      title: "Are you sure you want to " + action + " user account ?",
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
      cancelButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.users.update(payload).subscribe((response) => {
          if (response.code === 200) {
            this.get(this.selectedAdminArea);
            this.loading = false;
            //Swal.fire(response.description, '', 'success');
            setTimeout(() => {
              Swal.close();
            }, 1000);
          } else {
            // Swal.fire(response.description, '', 'error');
          }
        });
      } else if (result.isDismissed) {
        // Swal.fire('Canceled ,user account not ' + action + 'ed', '', 'info');
      }
    });
  }

  openDialog(data): void {
    this.userRoles(data);
    this.userDialog = this.dialog.open(UserDialogComponent, {
      width: "1000px",
      backdropClass: "custom-dialog-backdrop-class",
      panelClass: "custom-dialog-panel-class",
      disableClose: true,
      data: {
        userTypes: this.userTypes,
        rolesData: this.rolesList,
        positions: this.positions,
        ...data,
      },
    });

    this.userDialog.componentInstance.saveFunction.subscribe((payload) => {
      this.create(payload);
    });
  }

  openSearchDialog(data): void {
    this.userRoles(data);
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      width: "800px",
      backdropClass: "custom-dialog-backdrop-class",
      panelClass: "custom-dialog-panel-class",
      disableClose: true,
      data: {
        ...data,
      },
    });

    const sub = dialogRef.componentInstance.searchFunction.subscribe(
      (payload) => {
        this.selectedAdminArea = payload.area;
        this.searchKey = "Filtered Users of : " + payload.area.name;
        this.get(payload.area);
      }
    );
  }

  closeDialog() {
    //this.dialog.closeAll();
    this.userDialog.componentInstance.closeDialog();
  }

  clearSearch() {
    this.get();
    this.keyWord = "";
  }

  ngOnInit(): void {
    this.get();
    this.loadUserTypes();
    this.loadPositions();
    this.loadRoles();
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => sub.unsubscribe());
    }
  }

  loadUserTypes() {
    this.subs.push(
      this.service.getUserTypes().subscribe((response) => {
        this.userTypes = response.data
          .filter((el) => el.id !== 1)
          .map((type) => ({
            ...type,
          }));
      })
    );
  }

  loadPositions() {
    this.subs.push(
      this.service.getUserPositions().subscribe((response) => {
        this.positions = response.data.filter(
          (item) => item.visibilityLevel === 2
        );
      })
    );
  }

  loadRoles() {
    this.subs.push(
      this.service.roles().subscribe((response) => {
        this.roles = response.data;
      })
    );
  }

  openRoleDialog(data) {
    this.userRoles(data);

    const dialogRef = this.dialog.open(RoleDialogComponent, {
      width: "500px",
      backdropClass: "custom-dialog-backdrop-class",
      panelClass: "custom-dialog-panel-class",
      disableClose: true,
      data: {
        rolesData: this.rolesList,
        ...data,
      },
    });
    const sub = dialogRef.componentInstance.saveRolesFunction.subscribe(
      (payload) => {
        this.create(payload);
        this.closeDialog();
      }
    );
  }
  /** all getters here
   *
   */
  userRoles(user) {
    if (user.id) {
      this.rolesList = this.roles.map((resp) => ({
        ...resp,
        isChecked:
          user.roles.filter((r) => r.id === resp.id).length > 0 ? true : false,
      }));
    } else {
      this.rolesList = this.roles;
    }
  }

  get currentUser() {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user && user.data && user.data.principal
      ? user.data.principal
      : null;
  }

  loadUsers(data: PageEvent) {
    this.params.size = data.pageSize;
    this.params.page = data.pageIndex;
    this.get(this.selectedAdminArea);
  }

  filterData(keyWord) {
    if (keyWord.length > 2) {
      const payload = {
        searchKey: keyWord,
      };
      this.keyWord = keyWord;
      this.subs.push(
        this.users.searchByNamePhoneEmail(payload).subscribe((response) => {
          this.preparedUsersList(response);
          this.loading = false;
          this.params.total = response.totalElements;
        })
      );
    }

    if (keyWord === "") {
      this.get();
    }
  }
}
